import LAYOUT from '@/layouts/default/index.vue';

export default {
  path: '/dynamic',
  component: LAYOUT,
  name: 'Dynamic',
  redirect: '/dynamic/detail',
  meta: {
    title: '动态详情',
  },
  children: [
    {
      path: 'detail',
      name: 'DynamicDetail',
      meta: {
        title: '动态详情',
      },
      component: () => import('@/views/dynamic/detail'),
    },
  ],
};
